import React from 'react';

import { Skeletons } from '../../util-atomic';

const Loader = props => {
  return <div>
    <Skeletons.Xlarge />
    <Skeletons.Xlarge />
    <Skeletons.Xlarge />
    <Skeletons.Xlarge />
    <Skeletons.Large />
    <Skeletons.Medium />
    <Skeletons.Large />
  </div>
}

export default Loader;
